import { Col, Form, Row } from 'antd'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import CustomDebounceSelect from '../../../../elements/Select/CustomDebounceSelect'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { get } from 'lodash'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import React from 'react'

import { compose } from 'recompose'

const VendorSelect = compose(
  withUrlFetch({
    name: 'members',
    url: `members/list/organisation`,
  }),
  withSpinning,
)(CustomDebounceSelect)

function LinesImportForm(props) {
  let { order } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const vendor = getFieldValue('vendor._id') || ''

  const vendorQuotesURL = vendor
    ? `vendorQuotes/?owner=${vendor.replace(
        'members/',
        '',
      )}&select=_id,title,enquiry&status=Confirmed`
    : `vendorQuotes/?select=_id,title,enquiry&status=Confirmed`

  const [VendorQuoteSelect] = useFetchSelectUrl(
    {
      name: 'vendorQuotes',
      url: vendorQuotesURL,
    },
    [vendor],
  )

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Vendor'}>
            {getFieldDecorator('vendor._id', {
              initialValue: get(order, 'vendor._id'),
            })(
              <VendorSelect
                keyAtr={'_id'}
                valueAtr={'fn'}
                disabled={!!get(order, 'vendor._id')}
                placeholder="Select a Vendor Quote"
                style={{ width: '100%' }}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Vendor Quote'}>
            {getFieldDecorator('vendorQuote._id')(
              <VendorQuoteSelect
                keyAtr={'_id'}
                valueAtr={'title'}
                placeholder="Select a Vendor Quote"
                style={{ width: '100%' }}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

LinesImportForm.propTypes = {}
LinesImportForm.defaultProps = {}

export default Form.create()((LinesImportForm))
